export const LockAndDownloadMaterial = `query LockAndDownloadMaterial($filter: LockAndDownloadMaterialRequest!) {
  lockAndDownloadMaterial(filter: $filter) {
    name
    content
  }
}`;